import React, { useEffect } from "react";

import { MaterialReactTable } from "material-react-table";
import { sharedTableProps } from "../shared/tableProps";
import "../util/tables.css";
import { useDataView } from "../../contexts/data.view.context";
import ShowLoadingBar from "../util/showLoadingBar";
import { formatData } from "../util/formatData";

const columns = [
  {
    accessorKey: "Source",
    header: "Source",
    id: "Source",
    size: 100,
  },
  {
    accessorKey: "Entity",
    header: "Entity",
    id: "Entity",
    size: 100,
  },
  {
    accessorKey: "Today",
    header: "Today",
    id: "Today",
    size: 30,
  },
  {
    accessorKey: "Yesterday",
    header: "Yesterday",
    id: "Yesterday",
    size: 75,
  },
  {
    accessorKey: "Last_7_Days",
    header: "Last 7 Days",
    id: "Last_7_Days",
    size: 75,
  },
  {
    accessorKey: "Last_30_Days",
    header: "Last 30 Days",
    id: "Last_30_Days",
    size: 50,
  },
];

const ErrorLogReport = () => {
  const { fetchErrorLogReport, errorLogReport } = useDataView();
  let loading = false;

  useEffect(() => {
    (async () => {
      if (errorLogReport.length === 0) await fetchErrorLogReport();
    })();
    // eslint-disable-next-line
  }, []);

  if (errorLogReport.length === 0) {
    loading = true;
  } else {
    loading = false;
  }

  if (Boolean(loading)) {
    return <ShowLoadingBar title="Error Log Report" loading={loading} />;
  }

  return (
    <div className="relative">

      {errorLogReport.length > 0 && (
        <MaterialReactTable
          {...sharedTableProps}
          columns={columns}
          data={errorLogReport.map((errorlog) => {
            let today = errorlog["Error Log Count Today until Now"];
            let last_30_days = errorlog["Error Log Count Last 30 Days"];
            let last_7_days = errorlog["Error Log Count Last 7 Days"];
            let yesterday = errorlog["Error Log Count Yesterday"];

            today = formatData(today);
            last_30_days = formatData(last_30_days);
            last_7_days = formatData(last_7_days);
            yesterday = formatData(yesterday);

            return {
              Source: errorlog.Source,
              Entity: errorlog.Entity,
              Today: today,
              Last_30_Days: last_30_days,
              Last_7_Days: last_7_days,
              Yesterday: yesterday,
            };
          })}
          initialState={{
            density: "compact",
            pagination: { pageSize: 20 },
            sorting: [
              { id: "Today", desc: true }, // ✅ latest first
            ],
          }}
          autoResetPageIndex={false}
        />
      )}
    </div>
  );
};

export default ErrorLogReport;
